import { H1 } from '@atlassian/amkt-common';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import styles from './SmallHero.less';

export default class SmallHero extends Component {
  static props = {
    discoverHeading: PropTypes.string.isRequired,
    screenClass: PropTypes.oneOf(['md', 'sm', 'xs']).isRequired,
  };

  render() {
    const { props } = this;
    return (
      <div className={styles.hero}>
        {/* @ts-expect-error [MC-2850] - TS2339 - Property 'screenClass' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'. | TS2339 - Property 'discoverHeading' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'. */}
        <H1 className={styles[props.screenClass]}>{props.discoverHeading}</H1>
      </div>
    );
  }
}
